import { jsx } from "react/jsx-runtime";
import { Component } from "react";
import { withTheme } from "styled-components";
const _SpinningCircle = class _SpinningCircle extends Component {
  constructor(props) {
    super(props);
    this._start = null;
    this._stop = false;
    this._spinCircle = (timestamp) => {
      if (!this._stop) {
        if (!this._start) {
          this._start = timestamp;
        }
        const progress = timestamp - this._start;
        const c2 = this.state.circleCircumference;
        this.setState({
          // Moving from 0 and c, every period
          strokeDashoffset: progress / (this.props.period ?? _SpinningCircle.defaultProps.period) * c2 % c2
        });
        window.requestAnimationFrame(this._spinCircle);
      }
    };
    const r = props.r ?? _SpinningCircle.defaultProps.r;
    const c = Math.PI * r * 2;
    this.state = {
      circleRadius: r,
      circleCircumference: c,
      strokeDasharray: c / ((props.arcs ?? _SpinningCircle.defaultProps.arcs) * 2),
      strokeDashoffset: 2
    };
  }
  componentDidMount() {
    this._start = null;
    this._stop = false;
    if (window.requestAnimationFrame) {
      window.requestAnimationFrame(this._spinCircle);
    }
  }
  componentWillUnmount() {
    this._stop = true;
  }
  render() {
    const {
      cx,
      cy,
      color,
      strokeWidth,
      theme
    } = this.props;
    const {
      circleRadius,
      strokeDasharray,
      strokeDashoffset
    } = this.state;
    return /* @__PURE__ */ jsx("svg", { children: /* @__PURE__ */ jsx("circle", { cx, cy, r: circleRadius, fill: "transparent", stroke: color || theme.constellation.colors.blue500, strokeWidth, strokeDasharray, style: {
      strokeDashoffset
    } }) });
  }
};
_SpinningCircle.defaultProps = {
  className: "rd3-linechart-spinning-circle",
  r: 10,
  strokeWidth: "3px",
  arcs: 8,
  period: 2e3
};
let SpinningCircle = _SpinningCircle;
const SpinningCircle$1 = withTheme(SpinningCircle);
export {
  SpinningCircle$1 as default
};
